const zips = require('zips');

export const isUsaZip = zip => {
    return zips.getByZipCode(zip) ? true : false;
};
